import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { AdmissionAdminApi } from "../../../api/admission_admin/admission_admin.api";
import StatusCustom from "../../../components/status/statusCustom";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { VisaFormApi } from "../../../api/visa-form/visa-form.api";
import { VisaTypeApi } from "../../../api/visa-type/visa-type.api";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { RootState } from "../../../store/store";
import { checkPermission, permission_config } from "../../../utils/app.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission(`MANAGE_REQUEST_FORMS`, permission)
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");

    const [data, setData] = useState<any[]>([]);
    const [visaType, setVisaType] = useState<any[]>([]);


    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "left", label: t("ชื่อฟอร์มคำร้อง")
        },

        {
            id: "detail", disablePadding: false, align: "left", width: 250, label: t("รูปแบบฟอร์มคำร้อง")
        },
        {
            id: "status", disablePadding: false, align: "left", width: 80, label: t("สถานะ")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        // {
        //     id: "status", disablePadding: false, align: "center", width: 181, label: t("LIST_APPLICANTS_STATUS")
        // },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 150, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            visa_form_name,
            status,
            created_date,
            modified_date,
            visa_type_name,
            modified_name,
            id_visa_form
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: visa_form_name || "-",
                },


                {
                    option: "TEXT",
                    align: "left",
                    label: visa_type_name || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <SwitchCustom
                        disabled={!checkPermit.isUpdate}
                        checked={status === 'active'} onChange={(st) => handleChangeStatus(id_visa_form, st ? "active" : "inactive")} />,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },


                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     component: <StatusCustom
                //         disableMaxWidth
                //         text={renderStatus(admission_status)}
                //         type={renderStatus(admission_status)}
                //     />,
                // },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.request_form.manage_request_form_detail.replace(':id', id_visa_form))}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit={checkPermit?.isUpdate}
                            enableView={checkPermit?.isView}
                            enableDelete={checkPermit?.isDelete}
                            onViewClick={() => navigate(routeName.request_form.manage_request_form_view.replace(':id', id_visa_form))}
                            onEditClick={() => navigate(routeName.request_form.manage_request_form_detail.replace(':id', id_visa_form))}
                            onDeleteClick={() => handleDeleteList(id_visa_form)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_visa_form: number) => {
        alertActive(t("ฟอร์มคำร้อง"), t("ต้องการลบฟอร์มคำร้อง ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await VisaFormApi.status({ status: 'delete', }, id_visa_form).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleChangeStatus = async (id_visa_form: number, status: string) => {
        await VisaFormApi.status({ status: status, }, id_visa_form).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (status !== 'ALL') query = { ...query, id_visa_type: status }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }

        dispatch(setLoading());
        await VisaFormApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getVisaType()
    }, [])
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        visaType,
        status,
        set_status,
        checkPermit
    }
}

export default ManageState